import React, { useState, useEffect, useCallback } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import axios from 'axios';
import { BASEURL } from "../../constants/Common"
import './calendarstyles.css';

const localizer = momentLocalizer(moment);

interface TasksEvent {
    id: number;
    title: string;
    start: Date;
    end: Date;
}

interface ProjectWeeklyTasksProps {
    project_id: number;
    orgid: string | null;
}
const userid = localStorage.getItem('userid');

//const ProjectWeeklyTasks = ({ project_id }: { project_id: any }) => {
const ProjectWeeklyTasks: React.FC<ProjectWeeklyTasksProps> = ({ project_id, orgid }) => {
    const [taskDetails, setTaskDetails] = useState<TasksEvent[] | null>(null);

    const fetchTaskDetails = useCallback(async () => {
        const userid = localStorage.getItem('userid');
        if (!userid) {
            console.error('User ID not found');
            return;
        }

        try {
            const status_url = `${BASEURL}/projects/week_activities/${project_id}?orgid=${orgid}&userid=${userid}`;
            const response = await axios.get(status_url, {
                headers: { Accept: 'application/json' },
            });

            const project_tasks: any[] = response.data.activities;
            const tasks: TasksEvent[] = project_tasks.map((item: any) => ({
                id: item.id,
                title: item.project_code + " - " + item.activity_name,
                start: new Date(item.activity_start_date),
                end: calculateEndDate(item.activity_start_date, item.activity_duration)
            }));
            setTaskDetails(tasks);
        } catch (error) {
            console.log('Error fetching task details:', error);
        }
    }, [project_id, orgid]);

    useEffect(() => {
        fetchTaskDetails();
    }, [fetchTaskDetails]);

    function calculateEndDate(startDate: string, duration: number): Date {
        const startDateObj = new Date(startDate);
        const endDateObj = new Date(startDateObj);
        endDateObj.setDate(startDateObj.getDate() + duration);
        return endDateObj;
    }

    const eventPropGetter = (event: any, start: any, end: any, isSelected: any) => {
        let style = {
            backgroundColor: 'green',
            height: 'auto',
            whiteSpace: 'normal',
        };
        return {
            style: style,
        };
    };

    return (
        <div style={{ height: 65, margin: '10px', marginLeft: '-1px' }}>

            <Calendar
                localizer={localizer}
                events={taskDetails || []} // Use an empty array if taskDetails is null
                startAccessor="start"
                endAccessor="end"
                views={['week']}
                defaultView="week"
                titleAccessor="title"
                eventPropGetter={eventPropGetter}
                components={{
                    toolbar: () => null, // Hide the toolbar/header
                }}

            />
        </div>
    );
}

export default ProjectWeeklyTasks;
